module.exports = __webpack_public_path__ + "static/img/banner_default_4.9969c29a.png";